(function() {
  'use strict';

  angular.module('ringbaPortal').directive('trCallbacks', trCallbacks);

  function trCallbacks() {
    const directive = {
      restrict: 'E',
      scope: {},
      controller: 'CallbacksController',
      controllerAs: 'vm',
      bindToController: true,
      templateUrl: '/scripts/components/callbacks/callbacks.view.html'
    };
    return directive;
  }
})();
